<template>
  <div class="message-button">
    <button class="button accent-button tr-card" @click.stop="show = true">
      <i v-if="iconEmail" class="icon-email-lined" />
      {{ $t('common.write') }}
      <span v-if="extendTitle">&nbsp;{{ $t('common.to_coach') }}</span>
      <span class="d-none d-lg-inline-block"
        >&nbsp;{{ $t('common.to_coach') }}</span
      >
    </button>
    <el-dialog
      :title="$t('common.message_to_coach')"
      :visible.sync="show"
      width="100%"
      :modal-append-to-body="false"
      :center="true"
      :lock-scroll="true"
    >
      <WriteToTrainer
        :trainer-name="trainerName"
        :trainer-id="trainerId"
        @clicked="show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import WriteToTrainer from '~/components/Search/WriteToTrainer'
export default {
  name: 'MessageButton',
  components: {
    WriteToTrainer
  },
  props: {
    trainerName: {
      type: String,
      default: ''
    },
    trainerId: {
      type: Number,
      default: 0
    },
    iconEmail: {
      type: Boolean,
      default: true
    },
    extendTitle: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: false
  })
}
</script>

<style scoped lang="scss">
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: max-content;
  padding: 0 10px;

  .icon-email-lined {
    font-size: 18px;
    margin-right: 4px;
  }
}

.icon-email-lined {
  display: none;
}

@media (min-width: 376px) and (max-width: 992px) {
  .icon-email-lined {
    display: inline-block;
  }
}

@media (min-width: 768px) {
  .bottom-block {
    .message-button {
      .tr-card,
      span {
        font-size: 17px;
        font-weight: 400;
      }
    }
  }
}
</style>
